// This is a modal for Referralstwo

import { useDispatch } from "react-redux";
import CheckBoxComponent from "./CheckBox";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import { CheckIcon, XMarkIcon } from "./assets";
import { countriesOptions } from "./countriesOptions";
import GenericModal from "./GenericModal";
import ModalReferralAgreeTerms from "./ModalReferralAgreeTerms";
import SearchSelect from "./prtnr/ui/SearchSelect";
import { createReferral } from "./redux/slices/ReferralsThunks";
import { triggerFirstReferralCelebration } from "./redux/slices/CelebrationSlice";
import { isValidURL } from "./utils/func";
import { trackReferralSubmitted } from "./utils/analytics";

export default function ModalReferralstwo({ onClose, VendorId }) {
  const dispatch = useDispatch();
  const [checked, setchecked] = useState(false);
  const member = JSON.parse(localStorage.getItem("member"));
  const [submissionError, setSubmissionError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [showForm, setshowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const formRef = useRef(null);
  const [isUrgent, setisUrgent] = useState(false);

  const scrollToTop = () => {
    if (formRef.current) {
      formRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  const [errors, setErrors] = useState({
    companyWebsite: "",
    sector: "",
    location: "",
    budget: "",
    decisionMaker: "",
    urgentProblem: "",
    timeframe: "",
    context: "",
    terms: "",
  });

  const [formValues, setFormValues] = useState({
    companyWebsite: "",
    sector: "",
    location: "",
    budget: "",
    decisionMaker: "",
    urgentProblem: "",
    timeframe: "",
    context: "",
  });

  const handleChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));

    setErrors((prev) => ({
      ...prev,
      [key]: "",
    }));
  };

  const handleSubmit = async () => {
    // Prevent double submission
    if (isSubmitting) return;
    setIsSubmitting(true);
    const newErrors = {};
    Object.entries(formValues).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "This field is required";
      }
    });

    if (formValues.companyWebsite && !isValidURL(formValues.companyWebsite)) {
      newErrors.companyWebsite =
        "Invalid website. Use a full URL like https://example.com";
    }

    if (!checked) {
      newErrors.terms = "You must agree to the terms & conditions.";
    }

    if (Object.keys(newErrors).length > 0 || !checked) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return;
    }

    setErrors({});

    const date = new Date().toISOString();

    const payload = {
      company_website_url: formValues.companyWebsite,
      location: formValues.location,
      industry_sector: formValues.sector,
      vendor_id: VendorId,
      has_budget: formValues.budget,
      timeframe: formValues.timeframe,
      relevant_context_of_referral: formValues.context,
      is_decision_maker: formValues.decisionMaker === "Yes",
      urgent_problem: formValues.urgentProblem === "Yes",
      created_at: date,
      updated_at: date,
      referral_member_status: "Tracking",
      referral_status: "Lead Identified",
      is_urgent: isUrgent,
    };

    const res = await dispatch(createReferral(payload));

    if (createReferral.rejected.match(res)) {
      setSubmissionError(res.payload || "Failed to create referral");
      setIsSubmitting(false);
      return;
    }
    // ✅ SUCCESS → TRACK HERE
    trackReferralSubmitted(VendorId);
    setIsSubmitting(false);

    // Check if this is the user's first referral and trigger celebration
    if (res.payload?.isFirstReferral) {
      dispatch(triggerFirstReferralCelebration());
    }

    onClose();
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <RootWrapperModalReferralstwo>
      <Overlay>
        <Wrapper>
          <RefferalForm>
            <Left>
              <Frame58>
                <Frame1391>
                  <SubmitAReferral>Submit a Referral</SubmitAReferral>
                  <UseThisFormToMakeAReferralToTheVendorsThatCanHelpYourFriendsYouWillBeReceiveAFixedReferralRewardIfItSSuccessful>
                    Use this form to make a referral to the vendors that can
                    help your friends. You will be receive a Fixed Referral
                    Reward if it's successful.
                  </UseThisFormToMakeAReferralToTheVendorsThatCanHelpYourFriendsYouWillBeReceiveAFixedReferralRewardIfItSSuccessful>
                </Frame1391>
                <Frame1391>
                  <PRTNR.Input
                    label="Potential Client's Website"
                    value={formValues.companyWebsite}
                    onChange={(e) =>
                      handleChange("companyWebsite", e.target.value)
                    }
                    required
                    error={!!errors.companyWebsite}
                    errorMessage={errors.companyWebsite}
                  />

                  <Frame1416>
                    <PRTNR.Select
                      label="Sector"
                      value={formValues.sector}
                      onChange={(val) =>
                        handleChange("sector", val.target.value)
                      }
                      required
                      error={!!errors.sector}
                      errorMessage={errors.sector}
                      options={[
                        {
                          value: "Technology / Software / SaaS",
                          label: "Technology / Software / SaaS",
                        },
                        {
                          value: "Financial Services",
                          label: "Financial Services",
                        },
                        {
                          value: "Healthcare / Life Sciences",
                          label: "Healthcare / Life Sciences",
                        },
                        { value: "Manufacturing", label: "Manufacturing" },
                        {
                          value: "Retail / Consumer Goods",
                          label: "Retail / Consumer Goods",
                        },
                        {
                          value: "Transportation / Logistics",
                          label: "Transportation / Logistics",
                        },
                        {
                          value: "Hospitality & Travel",
                          label: "Hospitality & Travel",
                        },
                        {
                          value: "Professional Services / Consulting",
                          label: "Professional Services / Consulting",
                        },
                        {
                          value: "Education / Professional Development",
                          label: "Education / Professional Development",
                        },
                        {
                          value: "Non-Profit / NGO",
                          label: "Non-Profit / NGO",
                        },
                        {
                          value: "Government / Public Sector",
                          label: "Government / Public Sector",
                        },
                        {
                          value: "Energy / Utilities",
                          label: "Energy / Utilities",
                        },
                        {
                          value: "Media / Entertainment",
                          label: "Media / Entertainment",
                        },
                        {
                          value: "Real Estate / Construction",
                          label: "Real Estate / Construction",
                        },
                        {
                          value: "Telecommunications",
                          label: "Telecommunications",
                        },
                      ]}
                    />

                    <SearchSelect
                      label="Primary Location"
                      value={formValues.location}
                      onChange={(e) => handleChange("location", e.target.value)}
                      options={countriesOptions}
                      required
                      error={!!errors.location}
                      errorMessage={errors.location}
                    />
                  </Frame1416>

                  <PRTNR.Select
                    label="Does your friend have a budget to work to?"
                    value={formValues.budget}
                    onChange={(e) => handleChange("budget", e.target.value)}
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    required
                    error={!!errors.budget}
                    errorMessage={errors.budget}
                  />

                  <PRTNR.Select
                    label="Is your friend a decision maker?"
                    value={formValues.decisionMaker}
                    onChange={(val) =>
                      handleChange("decisionMaker", val.target.value)
                    }
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    required
                    error={!!errors.decisionMaker}
                    errorMessage={errors.decisionMaker}
                  />

                  <PRTNR.Select
                    label="Does your friend have an urgent problem or need to address?"
                    value={formValues.urgentProblem}
                    onChange={(val) =>
                      handleChange("urgentProblem", val.target.value)
                    }
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    required
                    error={!!errors.urgentProblem}
                    errorMessage={errors.urgentProblem}
                  />

                  <PRTNR.Select
                    label="In what timeframe will they need a solution?"
                    value={formValues.timeframe}
                    onChange={(val) =>
                      handleChange("timeframe", val.target.value)
                    }
                    required
                    error={!!errors.timeframe}
                    errorMessage={errors.timeframe}
                    options={[
                      {
                        value:
                          "Urgent (0–30 days): Immediate needs, budget approval, and ready to implement quickly",
                        label:
                          "Urgent (0–30 days): Immediate needs, budget approval, and ready to implement quickly",
                      },
                      {
                        value:
                          "Near-term (1–3 months): Actively evaluating solutions with a clear timeline",
                        label:
                          "Near-term (1–3 months): Actively evaluating solutions with a clear timeline",
                      },
                      {
                        value:
                          "Mid-term (3–6 months): In planning stages with defined but not urgent needs",
                        label:
                          "Mid-term (3–6 months): In planning stages with defined but not urgent needs",
                      },
                      {
                        value:
                          "Long-term (6+ months): In early research phase or planning for future needs",
                        label:
                          "Long-term (6+ months): In early research phase or planning for future needs",
                      },
                    ]}
                  />
                  <PRTNR.TextArea
                    value={formValues.context}
                    onChange={(e) => handleChange("context", e.target.value)}
                    label={"Please share any relevant context of your referral"}
                    required
                    error={!!errors.context}
                    errorMessage={errors.context}
                  />
                </Frame1391>

                <Frame1416>
                  <CheckBoxComponent
                    label={"Is this an urgent referral?"}
                    checked={isUrgent}
                    onChange={() => {
                      setisUrgent(!isUrgent);
                    }}
                  />
                  <CheckBoxComponent
                    label={
                      <span>
                        I have read and agreed to Paartner's{" "}
                        <span
                          onClick={(e) => {
                            e.stopPropagation(); // ✅ prevent bubbling to checkbox
                            e.preventDefault(); // ✅ stop label default behavior
                            openModal();
                          }}
                          style={{
                            color: "rgba(97, 98, 197, 1)",
                            cursor: "pointer",
                          }}
                        >
                          Terms & Conditions
                        </span>
                        .
                      </span>
                    }
                    checked={checked}
                    onChange={() => {
                      setchecked(!checked);
                    }}
                  />
                  {errors.terms && <ErrorMessage>{errors.terms}</ErrorMessage>}
                  {submissionError && (
                    <ErrorMessage>{submissionError}</ErrorMessage>
                  )}
                </Frame1416>
                <Frame59>
                  <div>
                    <PRTNR.Button onClick={() => onClose()} variant="gray">
                      Back
                    </PRTNR.Button>
                  </div>
                  <div>
                    <PRTNR.Button onClick={() => handleSubmit()} disabled={isSubmitting}>
                      {isSubmitting ? "Submitting..." : "  Submit Referral "}
                    </PRTNR.Button>
                  </div>
                </Frame59>
              </Frame58>
            </Left>
            {isMobile && showForm ? (
              <>
                <Left2
                  ref={formRef}
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  <Frame58>
                    <Frame1391>
                      <SubmitAReferral>Submit a Referral</SubmitAReferral>
                      <UseThisFormToMakeAReferralToTheVendorsThatCanHelpYourFriendsYouWillBeReceiveAFixedReferralRewardIfItSSuccessful>
                        Use this form to make a referral to the vendors that can
                        help your friends. You will be receive a Fixed Referral
                        Reward if it's successful.
                      </UseThisFormToMakeAReferralToTheVendorsThatCanHelpYourFriendsYouWillBeReceiveAFixedReferralRewardIfItSSuccessful>
                    </Frame1391>
                    <Frame1391>
                      <PRTNR.Input
                        label="Potential Client's Website"
                        value={formValues.companyWebsite}
                        onChange={(e) =>
                          handleChange("companyWebsite", e.target.value)
                        }
                        required
                        error={!!errors.companyWebsite}
                        errorMessage={errors.companyWebsite}
                      />

                      <Frame1416>
                        <PRTNR.Select
                          label="Sector"
                          value={formValues.sector}
                          onChange={(val) =>
                            handleChange("sector", val.target.value)
                          }
                          required
                          error={!!errors.sector}
                          errorMessage={errors.sector}
                          options={[
                            {
                              value: "Technology / Software / SaaS",
                              label: "Technology / Software / SaaS",
                            },
                            {
                              value: "Financial Services",
                              label: "Financial Services",
                            },
                            {
                              value: "Healthcare / Life Sciences",
                              label: "Healthcare / Life Sciences",
                            },
                            { value: "Manufacturing", label: "Manufacturing" },
                            {
                              value: "Retail / Consumer Goods",
                              label: "Retail / Consumer Goods",
                            },
                            {
                              value: "Transportation / Logistics",
                              label: "Transportation / Logistics",
                            },
                            {
                              value: "Hospitality & Travel",
                              label: "Hospitality & Travel",
                            },
                            {
                              value: "Professional Services / Consulting",
                              label: "Professional Services / Consulting",
                            },
                            {
                              value: "Education / Professional Development",
                              label: "Education / Professional Development",
                            },
                            {
                              value: "Non-Profit / NGO",
                              label: "Non-Profit / NGO",
                            },
                            {
                              value: "Government / Public Sector",
                              label: "Government / Public Sector",
                            },
                            {
                              value: "Energy / Utilities",
                              label: "Energy / Utilities",
                            },
                            {
                              value: "Media / Entertainment",
                              label: "Media / Entertainment",
                            },
                            {
                              value: "Real Estate / Construction",
                              label: "Real Estate / Construction",
                            },
                            {
                              value: "Telecommunications",
                              label: "Telecommunications",
                            },
                          ]}
                        />

                        <SearchSelect
                          label="Primary Location"
                          value={formValues.location}
                          onChange={(e) =>
                            handleChange("location", e.target.value)
                          }
                          options={countriesOptions}
                          required
                          error={!!errors.location}
                          errorMessage={errors.location}
                        />
                      </Frame1416>

                      <PRTNR.Select
                        label="Does your friend have a budget to work to?"
                        value={formValues.budget}
                        onChange={(e) => handleChange("budget", e.target.value)}
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        required
                        error={!!errors.budget}
                        errorMessage={errors.budget}
                      />

                      <PRTNR.Select
                        label="Is your friend a decision maker?"
                        value={formValues.decisionMaker}
                        onChange={(val) =>
                          handleChange("decisionMaker", val.target.value)
                        }
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        required
                        error={!!errors.decisionMaker}
                        errorMessage={errors.decisionMaker}
                      />

                      <PRTNR.Select
                        label="Does your friend have an urgent problem or need to address?"
                        value={formValues.urgentProblem}
                        onChange={(val) =>
                          handleChange("urgentProblem", val.target.value)
                        }
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        required
                        error={!!errors.urgentProblem}
                        errorMessage={errors.urgentProblem}
                      />

                      <PRTNR.Select
                        label="In what timeframe will they need a solution?"
                        value={formValues.timeframe}
                        onChange={(val) =>
                          handleChange("timeframe", val.target.value)
                        }
                        required
                        error={!!errors.timeframe}
                        errorMessage={errors.timeframe}
                        options={[
                          {
                            value:
                              "Urgent (0–30 days): Immediate needs, budget approval, and ready to implement quickly",
                            label:
                              "Urgent (0–30 days): Immediate needs, budget approval, and ready to implement quickly",
                          },
                          {
                            value:
                              "Near-term (1–3 months): Actively evaluating solutions with a clear timeline",
                            label:
                              "Near-term (1–3 months): Actively evaluating solutions with a clear timeline",
                          },
                          {
                            value:
                              "Mid-term (3–6 months): In planning stages with defined but not urgent needs",
                            label:
                              "Mid-term (3–6 months): In planning stages with defined but not urgent needs",
                          },
                          {
                            value:
                              "Long-term (6+ months): In early research phase or planning for future needs",
                            label:
                              "Long-term (6+ months): In early research phase or planning for future needs",
                          },
                        ]}
                      />
                      <PRTNR.TextArea
                        value={formValues.context}
                        onChange={(e) =>
                          handleChange("context", e.target.value)
                        }
                        label={
                          "Please share any relevant context of your referral"
                        }
                        required
                        error={!!errors.context}
                        errorMessage={errors.context}
                      />
                    </Frame1391>

                    <Frame1416>
                      <CheckBoxComponent
                        label={"Is this an urgent referral?"}
                        checked={isUrgent}
                        onChange={() => {
                          setisUrgent(!isUrgent);
                        }}
                      />
                      <CheckBoxComponent
                        label={
                          <span>
                            I have read and agreed to Paartner's{" "}
                            <span
                              onClick={(e) => {
                                e.stopPropagation(); // ✅ prevent bubbling to checkbox
                                e.preventDefault(); // ✅ stop label default behavior
                                openModal();
                              }}
                              style={{
                                color: "rgba(97, 98, 197, 1)",
                                cursor: "pointer",
                              }}
                            >
                              Terms & Conditions
                            </span>
                            .
                          </span>
                        }
                        checked={checked}
                        onChange={() => {
                          setchecked(!checked);
                        }}
                      />
                      {errors.terms && (
                        <ErrorMessage>{errors.terms}</ErrorMessage>
                      )}
                      {submissionError && (
                        <ErrorMessage>{submissionError}</ErrorMessage>
                      )}
                    </Frame1416>
                    <Frame59>
                      <div>
                        <PRTNR.Button onClick={() => onClose()} variant="gray">
                          Back
                        </PRTNR.Button>
                      </div>
                      <div>
                        <PRTNR.Button onClick={() => handleSubmit()} disabled={isSubmitting}>
                          {isSubmitting ? "Submitting..." : " Submit Referral "}
                        </PRTNR.Button>
                      </div>
                    </Frame59>
                  </Frame58>
                </Left2>
              </>
            ) : (
              <Right>
                {isMobile && <BestPractices2>Best Practices</BestPractices2>}
                <Frame1390>
                  <BestPractices>💡 Best Practices</BestPractices>
                  <Frame1393>
                    <Check src={CheckIcon} alt="Check" />
                    <AGoodReferralIsOneWhereYourFriendHasAProblemToSolveAChallengeToOvercomeOrAnAspirationToAchieve>
                      A good referral is one where your friend has a problem to
                      solve, a challenge to overcome or an aspiration to achieve
                    </AGoodReferralIsOneWhereYourFriendHasAProblemToSolveAChallengeToOvercomeOrAnAspirationToAchieve>
                  </Frame1393>
                  <Frame1393>
                    <Check src={CheckIcon} alt="Check" />
                    <WeMustAimToConnectYourFriendOrTheirCompanyToTheRightVendorAtTheRightTimeIdeallyThereIsAlreadyABudgetWhichTheyHaveAuthorityOverAnExistingNeedToSatisfyAndATimelineToPutASolutionInPlace>
                      We must aim to connect your friend, or their company, to
                      the right vendor, at the right time. Ideally, there is
                      already a Budget, which they have Authority over, an
                      existing Need to satisfy and a Timeline to put a solution
                      in place
                    </WeMustAimToConnectYourFriendOrTheirCompanyToTheRightVendorAtTheRightTimeIdeallyThereIsAlreadyABudgetWhichTheyHaveAuthorityOverAnExistingNeedToSatisfyAndATimelineToPutASolutionInPlace>
                  </Frame1393>
                  <Frame1393>
                    <Check src={CheckIcon} alt="Check" />
                    <ContextIsVitalAndHelpsTheVendorPrioritiseYourReferralAndUnderstandHowTheyCanHelp>
                      Context is vital and helps the vendor prioritise your
                      referral and understand how they can help
                    </ContextIsVitalAndHelpsTheVendorPrioritiseYourReferralAndUnderstandHowTheyCanHelp>
                  </Frame1393>
                  <Frame1393>
                    <Check src={CheckIcon} alt="Check" />
                    <WeEncourageYouToLetYourFriendsKnowThatYouWillBeUsingPaartnerToMakeYourReferrals>
                      We encourage you to let your friends know that you will be
                      using Paartner to make your referrals
                    </WeEncourageYouToLetYourFriendsKnowThatYouWillBeUsingPaartnerToMakeYourReferrals>
                  </Frame1393>
                  <Frame1393>
                    <Check src={XMarkIcon} alt="Cancel" />
                    <DoNotUseTheFormInTheHopeOfMakingAGeneralIntroductionThatTurnsIntoSomethingMorePaartnerThrivesOnFacilitatingSuccessfulReferralsBasedOnRealOpportunitiesToHelpFriends>
                      Do not use the form in the hope of making a general
                      introduction that turns into something more. Paartner
                      thrives on facilitating successful referrals based on real
                      opportunities to help friends.
                    </DoNotUseTheFormInTheHopeOfMakingAGeneralIntroductionThatTurnsIntoSomethingMorePaartnerThrivesOnFacilitatingSuccessfulReferralsBasedOnRealOpportunitiesToHelpFriends>
                  </Frame1393>
                  <Frame1393>
                    <Check src={XMarkIcon} alt="Cancel" />
                    <AsPerOurTermsAndConditionsDoNotSubmitAReferralIfYouHaveAConflictOfInterest>
                      As per our terms and conditions, do not submit a referral
                      if you have a conflict of interest.
                    </AsPerOurTermsAndConditionsDoNotSubmitAReferralIfYouHaveAConflictOfInterest>
                  </Frame1393>
                </Frame1390>
                {isMobile && (
                  <ButtonWrapper>
                    <PRTNR.Button
                      variant="black"
                      onClick={() => {
                        scrollToTop();
                        setshowForm(true);
                      }}
                    >
                      Okay
                    </PRTNR.Button>
                  </ButtonWrapper>
                )}
              </Right>
            )}
          </RefferalForm>
        </Wrapper>
      </Overlay>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalReferralAgreeTerms
          isOpen={isModalOpen}
          onClose={() => {
            closeModal();
            setchecked(true);
          }}
        />
      </GenericModal>

    </RootWrapperModalReferralstwo>
  );
}

const RootWrapperModalReferralstwo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  padding: 40px 24px 24px;
`;

const RefferalForm = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column-reverse;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column-reverse;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 528px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    display: none;
  }

  @media (max-width: 767px) {
    width: 100%;
    display: none;
  }
`;
const Left2 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 528px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SubmitAReferral = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const UseThisFormToMakeAReferralToTheVendorsThatCanHelpYourFriendsYouWillBeReceiveAFixedReferralRewardIfItSSuccessful = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1416 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: left;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 360px;
  box-sizing: border-box;
  padding: 32px 0px 16px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1390 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 12px;
  align-self: stretch;
  background: rgb(248, 250, 252);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const BestPractices = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    display: none;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;
const BestPractices2 = styled.span`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  /* H6 */
  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1393 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  max-width: 320px;
  width: 100%;
`;

const Check = styled.img`
  width: 14px;
  height: 24px;
`;

const AGoodReferralIsOneWhereYourFriendHasAProblemToSolveAChallengeToOvercomeOrAnAspirationToAchieve = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 306px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const WeMustAimToConnectYourFriendOrTheirCompanyToTheRightVendorAtTheRightTimeIdeallyThereIsAlreadyABudgetWhichTheyHaveAuthorityOverAnExistingNeedToSatisfyAndATimelineToPutASolutionInPlace = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 306px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ContextIsVitalAndHelpsTheVendorPrioritiseYourReferralAndUnderstandHowTheyCanHelp = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 306px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const WeEncourageYouToLetYourFriendsKnowThatYouWillBeUsingPaartnerToMakeYourReferrals = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 306px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const DoNotUseTheFormInTheHopeOfMakingAGeneralIntroductionThatTurnsIntoSomethingMorePaartnerThrivesOnFacilitatingSuccessfulReferralsBasedOnRealOpportunitiesToHelpFriends = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 308px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const AsPerOurTermsAndConditionsDoNotSubmitAReferralIfYouHaveAConflictOfInterest = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 308px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
